export default "__VITE_ASSET__BBPx7F5b__"